import { TicketStatus } from '@/services/TicketsService';

export function getStatusClassName(status: TicketStatus) {
  const classes: Record<TicketStatus, string> = {
    open: 'border-blue-200 bg-blue-50 text-blue-700',
    atendimento: 'border-amber-200 bg-amber-50 text-amber-700',
    finalized: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  };

  return classes[status];
}
